/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationtitlerequired3Inputs */

const en_dropvalidationtitlerequired3 = /** @type {(inputs: Dropvalidationtitlerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title is required`)
};

const de_dropvalidationtitlerequired3 = /** @type {(inputs: Dropvalidationtitlerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Title is required" |
*
* @param {Dropvalidationtitlerequired3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationtitlerequired3 = /** @type {((inputs?: Dropvalidationtitlerequired3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationtitlerequired3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationtitlerequired3(inputs)
	return de_dropvalidationtitlerequired3(inputs)
});
export { dropvalidationtitlerequired3 as "dropValidationTitleRequired" }